import Swiper, {Navigation, Pagination, Thumbs, Grid} from "swiper";
import $ from 'jquery';

new Swiper(".sliderProductsList-1", {
    modules: [Navigation],
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next-1",
        prevEl: ".swiper-button-prev-1",
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 30,
        }
    }
});

new Swiper(".sliderProductsList-2", {
    modules: [Navigation],
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next-2",
        prevEl: ".swiper-button-prev-2",
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 30,
        }
    }
});

new Swiper(".sliderProductsList-3", {
    modules: [Navigation],
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next-3",
        prevEl: ".swiper-button-prev-3",
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 30,
        }
    }
});


new Swiper(".mainSwiper", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".main-swiper-button-next",
        prevEl: ".main-swiper-button-prev",
    }
});

const swiper = new Swiper(".cartSwiper", {
    modules: [Grid, Navigation],
    spaceBetween: 12,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".cart-swiper-button-next",
        prevEl: ".cart-swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 3,
            spaceBetween: 20,
            direction: "horizontal",
        },
        370: {
            slidesPerView: 4,
            spaceBetween: 10,
            direction: "horizontal",
        },
        576: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        992: {
            direction: "horizontal",
        }
    }
});


const productViewSwiper = new Swiper(".cartSwiper2", {
    modules: [Grid, Navigation, Thumbs],
    spaceBetween: 10,
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".cart-big-swiper-button-next",
        prevEl: ".cart-big-swiper-button-prev",
    },
    passiveListeners: false,
});
const products = document.getElementsByClassName('app-variant-item');
productViewSwiper.on('slideNextTransitionStart', function (e) {
    let element = document.getElementsByClassName("swiper-slide-active")[1];
    let active_product = document.getElementsByClassName('app-variant-item active')[0];
    let active_productId = active_product.getAttribute("data-product-id");
    let attributeValue = element.getAttribute("data-product-id");
    let resultProductId = 0;
    let resultColor;
    for (let product of products) {
        if (attributeValue == product.getAttribute("data-product-id")) {
            resultProductId = attributeValue;
            resultColor = product;
        }
    }
    if (attributeValue != active_productId) {
        resultColor.click();
    }
});

productViewSwiper.on('slidePrevTransitionStart', function (e) {
    let element = document.getElementsByClassName("swiper-slide-active")[1];
    let active_product = document.getElementsByClassName('app-variant-item active')[0];
    let active_productId = active_product.getAttribute("data-product-id");
    let attributeValue = element.getAttribute("data-product-id");
    let resultProductId = 0;
    let resultColor;
    for (let product of products) {
        if (attributeValue == product.getAttribute("data-product-id")) {
            resultProductId = attributeValue;
            resultColor = product;
        }
    }
    if (attributeValue != active_productId) {
        resultColor.click([false]);
    }
});




new Swiper(".recommendationsSwiper", {
    modules: [Navigation, Grid],
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        nextEl: ".recommendations-swiper-button-next",
        prevEl: ".recommendations-swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 30,
        }
    }
});

new Swiper(".certificate-swiper", {
    modules: [Navigation, Grid],
    slidesPerView: 2,
    spaceBetween: 30,
    navigation: {
        nextEl: ".cart-big-swiper-button-next",
        prevEl: ".cart-big-swiper-button-prev",
    },
    breakpoints: {
        576: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    }
});



$(function () {
    $('.app-variant-item').on('click', function (direction = true) {
        if (direction) {
            productViewSwiper.slideTo($('.cartSwiper .swiper-slide[data-product-id=' + $(this).data('product-id') + ']').index());
        }
        else {
            productViewSwiper.slideTo($('.cartSwiper .swiper-slide[data-product-id=' + $(this).data('product-id') + ']').last());
        }
    });
});
